import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../api/axiosInstance";

const FeedbackResponses = () => {
  const { bootcampId } = useParams();
  const [responses, setResponses] = useState([]);

  useEffect(() => {
    const loadResponses = async () => {
      try {
        const res = await api.get(
          `/api/bootcamp/feedback-responses/${bootcampId}`
        );
        setResponses(res.data.responses);
      } catch (err) {
        console.error(err);
      }
    };

    loadResponses();
  }, [bootcampId]);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">
        Feedback Responses
      </h2>

      {responses.map((r, i) => (
        <div key={i} className="border p-4 mb-4 rounded">
          <p><strong>Name:</strong> {r.name}</p>
          <p><strong>Email:</strong> {r.email}</p>

          <div className="mt-3">
            {Object.entries(r.answers).map(([key, val]) => (
              <p key={key}>
                Q{Number(key) + 1}: {val}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeedbackResponses;